import React from "react";

import { CheckCircle2 } from "lucide-react";

import Button from "../../../../../Components/Button";
import CommonModal from "../../../../../Components/Modal";

export type SaveAccountsSuccessType = "watchlist" | "monitor";

interface SaveAccountsSuccessModalProps {
  isOpen: boolean;
  saveType: SaveAccountsSuccessType;
  watchlistName?: string;
  onClose: () => void;
  onGoToMonitored: () => void;
}

const SaveAccountsSuccessModal: React.FC<SaveAccountsSuccessModalProps> = ({
  isOpen,
  saveType,
  watchlistName,
  onClose,
  onGoToMonitored,
}) => {
  const isWatchlist = saveType === "watchlist";
  const title = isWatchlist
    ? "Watchlist created"
    : "Accounts added to monitored";
  const description = isWatchlist
    ? watchlistName
      ? `"${watchlistName}" is ready. Open the Watchlist tab to view it and manage account weights.`
      : "Your watchlist is ready. Open the Watchlist tab to view it and manage account weights."
    : "Selected accounts are now on your monitored list. Open the Others tab to review them.";
  const goToLabel = isWatchlist ? "Go to Watchlist" : "Go to Others";

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={onClose}
      size="md"
      title={title}
      footer={
        <div className="flex w-full flex-wrap items-center justify-end gap-2">
          <Button variant="outline-primary" onClick={onClose}>
            Stay here
          </Button>
          <Button variant="primary" onClick={onGoToMonitored}>
            {goToLabel}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-3 px-2 py-4 text-center">
        <CheckCircle2
          className="h-12 w-12 text-emerald-500"
          strokeWidth={1.75}
          aria-hidden
        />
        <p className="text-sm leading-relaxed text-gray-600">{description}</p>
      </div>
    </CommonModal>
  );
};

export default SaveAccountsSuccessModal;
